<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { ActiveQuestionReadModel } from '@Evaluation/Estimations/Domain/readmodels'
    import type { DiscreteScaleLevel } from '@Scales/Model'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        readModel: ActiveQuestionReadModel
    }>()

    const emit = defineEmits<{
        (e: 'update-value', value: number | null): void
        (e: 'update-comment', value: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- computed ----------------

    const hasScale = computed(() => (rm.value.ScaleLevels?.length ?? 0) > 0)

    const scaleLevels = computed<DiscreteScaleLevel[]>(() =>
        rm.value.ScaleLevels ?? []
    )

    const value = computed<number | null>({
        get: () => rm.value.GroupVoteValue,
        set: val => emit('update-value', val)
    })

    const comment = computed<string | null>({
        get: () => rm.value.GroupVoteComment,
        set: val => emit('update-comment', val)
    })
</script>


<template>
    <div style="min-height: 450px;">

        <input v-if="!hasScale" type="number" v-model.number="value" class="form-control" />

        <div v-if="hasScale" class="list-group">
            <a v-for="sl in scaleLevels" class="list-group-item list-group-item-action text-center"
               @click="value = sl.Value" :class="{'bg-success': value === sl.Value, 'bg-white': value !== sl.Value}">
                <strong>{{sl.Value}} - {{sl.Name}}</strong>
                <p v-if="sl.Definition" class="mb-0">{{sl.Definition}}</p>
            </a>
        </div>

        <div class="text-center">
            <button type="button" class="btn mt-3" :class="value == null ? 'btn-success' : 'btn-outline-secondary'" @click="value = null">
                <i class="fa-regular" :class="value == null ? 'fa-square-check' : 'fa-square'"></i>
                Follow the average (default)
            </button>
        </div>
        <br />

        <div style="margin-top: 15px;">
            <textarea rows="5" v-model.trim="comment" class="form-control" placeholder="Comment..." />
        </div>
    </div>
</template>